import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    Input,
    FormControl,
    FormLabel,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';

interface RenameDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onRename: (newTitle: string) => void;
    initialTitle: string;
    isLoading?: boolean;
}

export function RenameDialog({
    isOpen,
    onClose,
    onRename,
    initialTitle,
    isLoading = false,
}: RenameDialogProps) {
    const [title, setTitle] = useState(initialTitle);

    useEffect(() => {
        if (isOpen) {
            setTitle(initialTitle);
        }
    }, [isOpen, initialTitle]);

    const handleSubmit = () => {
        if (title.trim()) {
            onRename(title.trim());
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm">
            <ModalOverlay />
            <ModalContent borderRadius="xl">
                <ModalHeader>Rename Conversation</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl>
                        <FormLabel>Conversation Title</FormLabel>
                        <Input
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Enter new title..."
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') handleSubmit();
                            }}
                            autoFocus
                        />
                    </FormControl>
                </ModalBody>

                <ModalFooter>
                    <Button variant="ghost" mr={3} onClick={onClose} borderRadius="lg">
                        Cancel
                    </Button>
                    <Button
                        colorScheme="brand"
                        onClick={handleSubmit}
                        isLoading={isLoading}
                        borderRadius="lg"
                    >
                        Rename
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
